import { render } from "./CustomizedTriggerButtonOfNewTab.vue?vue&type=template&id=332e34aa"
import script from "./CustomizedTriggerButtonOfNewTab.vue?vue&type=script&lang=ts"
export * from "./CustomizedTriggerButtonOfNewTab.vue?vue&type=script&lang=ts"
script.render = render

export default script